import React from 'react'

export const GetNumber = () => {
  return (
  <>
  
  <div class="container-fluid wrapper" dir='rtl'>
    <div class="row d-flex align-items-center justify-content-center h-100 position-relative">
        <div class="col-sm-12 auth-responsive d-flex d-xl-none">
            <img src="../img/WLogo.png" width="200" alt="" />
        </div>
        <div class="col-sm-12 col-xl-3 d-flex justify-content-center align-items-center p-24">
            <div class="card auth-shadow login-card position-relative order-1">
                <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec1" />
                <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec2" />
                <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec1 bottom-0" />
                <div class="card-header bg-white border-0 p-0">
                    <div class="card-title text-center b-24">
                        <h1>تغیر با کد یک بار مصرف</h1>
                        <p class="m-0">
                            برای تغیر کلمه عبور شماره موبایل متصل به حساب خودرا وارد
                            نمایید
                        </p>
                    </div>
                </div>
                <div class="card-content">
                    <div class="form-group position-relative d-flex position-relative">
                        <input type="text" name="" placeholder="09130537010" maxLength={11}
                               class="form-control input-number text-end m-0" id="" />
                        <div class="position-absolute left-0 select-number-icon-wrapper">
                            <div class="devider"></div>
                            <img src="../img/Flag Pack.png" alt="" />
                            <img src="../icons/select arrow.svg" alt="" />
                        </div>
                    </div>
                    <button class="custom-btn-primary t-24 w-100">ارسال کد تایید</button>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-xl-9 d-none d-xl-flex justify-content-center align-items-center p-24 h-100 pr-0">
        <div class="auth-section-img position-relative d-flex justify-content-center align-items-center">
          <div class="position-absolute d-flex flex-column justify-content-center align-items-center">
            <img src="../img/WLogo.png" width="250" alt="" />
            <div class="d-flex flex-column">
              <h3>سلامت پایا</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

  </>
  )
}
